import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser, resetSessionExpired } from '../redux/actions/authActions';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SessionExpiredPopup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { isSessionExpired } = useSelector((state) => state.auth);

    // Don't show popup if user is viewing a shared chat
    const shareId = searchParams.get('shareId');
    if (!isSessionExpired || shareId) return null;

    const handleLoginAgain = () => {
        dispatch(resetSessionExpired());
        dispatch(logoutUser());
        navigate('/login');
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 transform transition-all scale-100">
                <div className="text-center">
                    <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
                        <svg
                            className="h-8 w-8 text-red-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            />
                        </svg>
                    </div>

                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Session Expired
                    </h3>

                    <p className="text-gray-500 mb-8">
                        You have been logged out because your session has expired or you logged in on another device. Please login again to continue.
                    </p>

                    <button
                        onClick={handleLoginAgain}
                        type='submit'
                        className="w-full bg-gray-900 text-white py-3 px-4 rounded-xl hover:bg-gray-800 focus:outline-none disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 font-light tracking-tight"
                    >
                        Login Again
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionExpiredPopup;
